import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@admin/shared/interceptors/auth.interceptor';
import { errorInterceptor } from '@admin/shared/interceptors/error.interceptor';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withPreloading } from '@angular/router';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { routes } from './app.routes';
import { provideEnvironment, providePrivanotTheme, provideToast } from '@privanot/shared-ui/providers';
import { environment } from '@admin/env/environment';
import { StaticTranslateLoader } from '@admin/shared/util/translate-loader';
import { getStoredLanguage } from '@admin/shared/util/language-storage';
import {
    Activity,
    Archive,
    ArrowLeft,
    ChevronDown,
    ChevronRight,
    CircleAlert,
    CircleCheck,
    CircleChevronRight,
    CircleDashed,
    CircleDot,
    CircleEllipsis,
    CircleQuestionMark,
    CircleX,
    Clock,
    Code,
    Copy,
    Eye,
    FileText,
    FolderKanban,
    FunnelX,
    Globe,
    Info,
    KeyRound,
    LayoutDashboard,
    LoaderCircle,
    LogOut,
    LUCIDE_ICONS,
    LucideIconProvider,
    Mail,
    MoonStar,
    Pencil,
    Plus,
    RefreshCw,
    RotateCcw,
    RotateCcwKey,
    Search,
    Settings,
    ShieldCheck,
    ShieldOff,
    Users,
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideHttpClient(withInterceptors([errorInterceptor, authInterceptor])),
        provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
        providePrivanotTheme({}),
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                Activity,
                Archive,
                ArrowLeft,
                ChevronDown,
                ChevronRight,
                CircleAlert,
                CircleCheck,
                CircleChevronRight,
                CircleDashed,
                CircleDot,
                CircleEllipsis,
                CircleQuestionMark,
                CircleX,
                Clock,
                Code,
                Copy,
                Eye,
                FileText,
                FolderKanban,
                FunnelX,
                Globe,
                Info,
                KeyRound,
                LayoutDashboard,
                LoaderCircle,
                LogOut,
                Mail,
                MoonStar,
                Pencil,
                Plus,
                RefreshCw,
                RotateCcw,
                RotateCcwKey,
                Search,
                Settings,
                ShieldCheck,
                ShieldOff,
                Users,
            }),
        },
        provideEnvironment(environment),
        provideToast(),
        provideTranslateService({
            lang: getStoredLanguage(),
            loader: { provide: TranslateLoader, useClass: StaticTranslateLoader },
        }),
    ],
};
